import { Cms } from '@typings';
import { createAction } from 'typesafe-actions';

export const setPageMeta = createAction('cms/SET_PAGE_META')<Cms.Page>();
